import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import SalesPerformanceMonthlySelloutParetoChartComponent from "../../../components/charts/xy/sales-performance-monthly-sellout-pareto-chart.component";
import paginationComponent from '../../../components/pagination/pagination.component';
import languageModel from '../../../models/language.model';
import PerformanceModel from '../../../models/task-management/performance.model';
import ViewBase from '../../view-base.view';

export default function SalesPerformanceMonthlySelloutView() {
  ViewBase.call(this);

  let currency = "";
  let isPageChange = false;
  let lstMonthlySellOutChartData = [];
  let lstSalePerformanceDetail = { data: [], pageIndex: 1, pageSize: 10, totalSize: 0, totalCount: 0 };
  let spmsReportCategory = 1;
  let inputFilter = { month: "" };
  let filter = Object.assign({ PageSize: 10, PageIndex: 1 }, inputFilter);
  let chartFilter = Object.assign({ PageSize: 20, PageIndex: 1 }, inputFilter);
  const SPMSREPORT_CATEGORY = [
    { id: 1, name: 'Amount' },
    { id: 2, name: 'Quantity' }
  ];

  var events = {
    onChartDataChanged: (_data, _spmsReportCategory) => { }
  };

  let setDefaultValue = () => {
    inputFilter.month = moment().format("YYYY-MM"); // Current month 
    if (inputFilter.month.length == 7) {
      filter.month = inputFilter.month.replace('-', '');
      chartFilter.month = inputFilter.month.replace('-', '');
    }
    onSearch();
  }

  let getFilters = () => {
    if (inputFilter.month.length == 7) {
      filter.month = inputFilter.month.replace('-', '');
      chartFilter.month = inputFilter.month.replace('-', '');
    }
  }

  let onSearch = () => {
    getFilters();
    getChartData();
    _search();
  }

  let getChartData = () => {
    this.showLoading();

    PerformanceModel.getSalesPerformancesSelloutbyMarketingName(chartFilter)
      .then((result) => {
        lstMonthlySellOutChartData = result.data;

        if (result.data && !isPageChange) {
          events.onChartDataChanged(lstMonthlySellOutChartData, spmsReportCategory);
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _search = () => {
    this.showLoading();

    PerformanceModel.getSalesPerformancesSelloutbyMarketingName(filter)
      .then((result) => {
        lstSalePerformanceDetail.data = result.data;
        lstSalePerformanceDetail.totalCount = result.total;
        lstSalePerformanceDetail.pageIndex = result.pageIndex;
        lstSalePerformanceDetail.pageSize = result.pageSize;

        if (lstSalePerformanceDetail.data && lstSalePerformanceDetail.data.length > 0) {
          currency = lstSalePerformanceDetail.data[0].currency;
        } else {
          currency = '';
        }
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    filter.PageIndex = pageIndex;
    filter.PageSize = pageSize;
    isPageChange = true;
    _search();
  }

  let onPageChanged = (pageIndex) => {
    filter.PageIndex = pageIndex;
    isPageChange = true;

    _search();
  }

  let _downloadExcel = () => {
    this.showLoading();
    let fileName = uuidv4();

    PerformanceModel.downloadMonthlySelloutExcel(chartFilter, fileName)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let selectReportCategory = (e) => {
    if (spmsReportCategory == e.target.dataset.id) return;
    spmsReportCategory = e.target.dataset.id;
    isPageChange = false;
    if (spmsReportCategory == 2) {
      chartFilter.sortBy = "Qty";
      chartFilter.OrderBy = "DESC";
      filter.sortBy = "Qty";
      filter.OrderBy = "DESC";
      onSearch();
    } else {
      chartFilter.sortBy = "";
      chartFilter.OrderBy = "";
      filter.sortBy = "";
      filter.OrderBy = "";
      onSearch();
    }
  }

  return {
    oninit: (vnode) => {
      setDefaultValue();
    },
    view: (vnode) => {
      return [
        m('.card.mb-3',
          m('.card-body',
            m('.row',
              m(".col-md-4",
                m("label.form-label", languageModel.getText("LT00000326", "Month")),
                m("input.form-control.form-control-bg",
                  {
                    "type": "month",
                    "value": inputFilter.month,
                    onchange: (e) => { inputFilter.month = e.target.value; isPageChange = false; onSearch(); }
                  }
                ),
              ),
              m(".col-md-5.d-flex.gap-3.align-items-center.flex-wrap", { "style": { "padding-top": "25px" } },
                SPMSREPORT_CATEGORY.map(rc =>
                  m(".d-flex.justify-content-left.gap-2", [
                    m("input.form-check-input", {
                      type: "radio",
                      name: "btnRadioReportCategory",
                      id: "btnRadioReportCategory" + rc.id,
                      checked: (rc.id == spmsReportCategory),
                      "data-id": rc.id,
                      onclick: selectReportCategory,
                    }),
                    m("label.form-check-label", {
                      "for": "btnRadioReportCategory" + rc.id,
                    },
                      rc.name
                    ),
                  ]),
                ),
              ),
            )
          )
        ),
        //chart
        lstSalePerformanceDetail.data.length > 0 &&
        m('.card.mb-3',
          m('.card-body.p-0',
            m(SalesPerformanceMonthlySelloutParetoChartComponent, { data: lstMonthlySellOutChartData, SPMSReportCategory: spmsReportCategory, events: events })
          )
        ),
        //List
        m('.card',
          m('.card-body',
            m('.d-flex.justify-content-end.mb-2',
              m('a.btn.btn-primary', { onclick: _downloadExcel },
                m('i.bi.bi-file-earmark-arrow-down-fill'), languageModel.getText("LT00000018", "Excel Download"),
              )
            ),
            m('.row',
              m(".col-12.p-0",
                m(".table-responsive",
                  m("table.table.table-bordered",
                    [
                      m("thead.thead-bggrey",
                        m("tr.align-middle", [
                          m("th", { "scope": "col" }, languageModel.getText("LT00000327", "GSCM Prod Group")),
                          m("th", { "scope": "col" }, languageModel.getText("LT00000328", "Marketing Name")),
                          m("th", { "scope": "col", "style": "width: 160px;" }, languageModel.getText("LT00000329", "Sellout Qty")),
                          m("th", { "scope": "col", "style": "width: 160px;" }, languageModel.getText("LT00000330", "Sellout Amount") + (_.isEmpty(currency) ? '' : ` (${currency})`)),
                        ])
                      ),
                      m("tbody",
                        lstSalePerformanceDetail.data.length == 0 &&
                        m("tr", { "class": "align-middle" },
                          m("td", { "colspan": "4" }, languageModel.getText("EM00000141", "No records found."))
                        ),
                        lstSalePerformanceDetail.data.map(pd => [
                          m("tr", [
                            m("td", pd.gscmProdGroup),
                            m("td", pd.marketingName),
                            m("td.text-end", pd.validEULAQty.toLocaleString()),
                            m("td.text-end", pd.validEULAAmt.toLocaleString()),
                          ])
                        ]),
                      )
                    ])
                ),
                !this.isLoading && m(".px-3",
                  m(paginationComponent, { currentPage: lstSalePerformanceDetail.pageIndex, pageSize: lstSalePerformanceDetail.pageSize, totalItems: lstSalePerformanceDetail.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                )
              )
            )
          )
        ),
        this.getBaseViews()
      ];
    }
  }
}